

export type GLTFLike<TScene = unknown> = {
    asset: {
        version: string,
        generator?: string,
        extras?: Record<string, unknown>;
    },
    animations: unknown[],
    scene: TScene,
    scenes: TScene[];

    parser?: unknown;
    userData?: Record<string, unknown>;
}


export function isGltfLike(obj: unknown): obj is GLTFLike {

    if (typeof obj !== "object" || obj === null) return false;

    const gltf = obj as GLTFLike;
    return typeof gltf.asset === "object"
        && typeof gltf.asset.version === "string"
        && Array.isArray(gltf.animations)
        && (gltf.scene !== undefined)
        && Array.isArray(gltf.scenes);
}